import { getTileData, IGetTileDataArgs, TDataValue } from "@components/dashboard/Dashboard.types";
import { useContext, useEffect, useState } from "react";

import { AppContext } from "../../../contexts/appContext/AppContext.types";

type UseDashboardTileProps<T> = {
    getTileDataArgs: {
        prop: TDataValue<T>;
        args: IGetTileDataArgs;
    };
    enabled?: boolean;
    skipError?: boolean;

};

export const useDashboardTile = <T>(props: UseDashboardTileProps<T>) => {
    const appContext = useContext(AppContext);
    const { prop, args } = props.getTileDataArgs;
    const { context = appContext, permissionContext, oData, signal } = args;
    const { enabled = true } = props;
    const [hasError, setError] = useState<boolean>(false);
    const [data, setData] = useState<T>(null);
    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let mounted = true;
        if (!context?.isLoadingCompany && enabled) {
            const loadData = async () => {
                try {
                    const data = await getTileData(prop, { context, permissionContext, oData, signal });
                    if(mounted) {
                        setData(data);
                    }
                } catch (e) {
                    if(!mounted) {
                        return;
                    }
                    if(!props.skipError) {
                        setError(true);
                    }
                    setData(null);
                    
                }
                finally {
                    if(mounted) {
                        setLoading(false);
                    }
                }
            };
    
            loadData();
        }
        

        return () => {
            mounted = false;
        };
    }, [context, prop, oData, permissionContext, signal, enabled, props.skipError, context?.isLoadingCompany]);

    return {
        hasError,
        data,
        isLoading
    };
};
